import { Annotation } from "../objects/Annotation.interface";
import { dbAnotadorInstance } from '../database/db';
import { PlaceNameStats, PlaceNameStatsItem } from '../objects/PlaceNameStats.interface';
import { removeRelatedAnnotationsKeepOne } from "../tools/Utils";

export const createNewAnnotation = (docId:number):Annotation => {
    var newAnnotation = {
        text: "",
        start: 0,
        end: 0,
        paragraph: "",
        documentId: docId,
        firstEntityId: -1,
        secondEntityId: -1,
        firstEntityCode: '',
        secondEntityCode: '',
        fieldsFirstEntity: [],
        fieldsSecondEntity: [],
        isUniqueMode: false,
        status: 'Draft',
        relatedTo: -1,
        relatedText: '',
        relatedKey: ''
    }

    return newAnnotation;
}

export class AnnotationService{


    getByDocumentId(id:number){
        const result = dbAnotadorInstance.annotations.where({documentId: id}).toArray();
        return result;
    }

    getAllAnnotations(){
        const result = dbAnotadorInstance.annotations.toArray();
        return result;
    }

    deleteBulk(keys:number[]){
        const result = dbAnotadorInstance.annotations.bulkDelete(keys);
        return result;
    }

    deleteUnique(key:number)
    {
        const result = dbAnotadorInstance.annotations.delete(key);
        return result;
    }

    addBulk(annotations:Annotation[]){
        const result = dbAnotadorInstance.annotations.bulkAdd(annotations);
        return result;
    }

    updateBulk(annotations:Annotation[]){
        var annotationsUpdate:any[] = [];
        annotations.forEach((annotation) =>
            {
                annotationsUpdate.push({
                    key:annotation.id!,
                    changes: {
                        text: annotation.text,
                        start: annotation.start,
                        end: annotation.end,
                        paragraph: annotation.paragraph,
                        documentId: annotation.documentId,
                        firstEntityId: annotation.firstEntityId,
                        secondEntityId: annotation.secondEntityId,
                        firstEntityCode: annotation.firstEntityCode,
                        secondEntityCode: annotation.secondEntityCode,
                        fieldsFirstEntity: annotation.fieldsFirstEntity,
                        fieldsSecondEntity: annotation.fieldsSecondEntity,
                        isUniqueMode: annotation.isUniqueMode,
                        status:annotation.status,
                        relatedTo: annotation.relatedTo,
                        relatedText: annotation.relatedText,
                        relatedKey: annotation.relatedKey
                    }
                });
            }
        );
        
        const result = dbAnotadorInstance.annotations.bulkUpdate(annotationsUpdate);
        return result;
    }

    update(annotation:Annotation){
        const result = dbAnotadorInstance.annotations.update(annotation.id!,{
                        firstEntityId: annotation.firstEntityId,
                        secondEntityId: annotation.secondEntityId,
                        firstEntityCode: annotation.firstEntityCode,
                        secondEntityCode: annotation.secondEntityCode,
                        fieldsFirstEntity: annotation.fieldsFirstEntity,
                        fieldsSecondEntity: annotation.fieldsSecondEntity,
                        isUniqueMode: annotation.isUniqueMode,
                        status:annotation.status,
                        relatedTo: annotation.relatedTo,
                        relatedText: annotation.relatedText,
                        relatedKey: annotation.relatedKey
                    });
        return result;
    }

    add(annotation:Annotation){
        const result =  dbAnotadorInstance.annotations.add(annotation);
        return result;
    }

    get(annId:number){
        const result = dbAnotadorInstance.annotations.where({id:annId}).first();
        return result;
    }


    async executeFieldCounter(documentId:number){
        return await this.getByDocumentId(documentId).then(annotations => {
            var annotationsKeepingOneRelated =  removeRelatedAnnotationsKeepOne(annotations).filter(item => item.status !== 'Draft');
            return this.updateFieldsCounter(annotationsKeepingOneRelated);
        });
    }
    
    updateFieldsCounter(annotations:Annotation[]){
        const placeNameStatsList:PlaceNameStats[] = this.buildPlaceNameStats(annotations);
        return placeNameStatsList;

    }

    private buildPlaceNameStats(annotations:Annotation[]):PlaceNameStats[]{
        var placeNameStatsList: PlaceNameStats[] = [];
        //map the fields that exists in the annotations
        var firstFieldsInDocumentList = annotations.map((annotation) => (annotation.fieldsFirstEntity) );
        var secondFieldsInDocumentList = annotations.map((annotation) => (annotation.fieldsSecondEntity) ); 
        
        var completeFieldsInDocument:string[] = [];
        firstFieldsInDocumentList.forEach(array => {
            if(array && array.length > 0)
            completeFieldsInDocument =completeFieldsInDocument.concat(array);
        });

        secondFieldsInDocumentList.forEach(array => {
            if(array && array.length > 0)
            completeFieldsInDocument =completeFieldsInDocument.concat(array);
        });
        
  
        //create PlaceNameStats for each field in document
        const uniqueArray: string[] = completeFieldsInDocument.filter((item, i, ar) => ar.indexOf(item) === i);
        uniqueArray.forEach(field =>  {
            var PlaceNameStatsItem: PlaceNameStatsItem[] = [];
            //get annotations that have this field code
            var annotationsWithThisField = annotations.filter((annotation) => annotation.fieldsFirstEntity?.includes(field) || annotation.fieldsSecondEntity?.includes(field));
            annotationsWithThisField = removeRelatedAnnotationsKeepOne(annotationsWithThisField);

            //get the text list with that field
            var annotationsText:string[] = annotationsWithThisField.map((annotation) => (annotation.relatedTo !== -1)?annotation.relatedText:annotation.text);
            const uniqueTextArray: string[] = annotationsText.filter((item, i, ar) => ar.indexOf(item) === i);


            uniqueTextArray.forEach(item => {

                var newPlaceNameStatItem: PlaceNameStatsItem = {
                    placeName: item,
                    count: annotationsText.reduce((accumulator, currentValue) => {
                        if (currentValue === item) {
                          return accumulator + 1;
                        }
                        return accumulator;
                      },0)
                };

                PlaceNameStatsItem.push(newPlaceNameStatItem);
            });

            var newPlaceNameStat: PlaceNameStats = {
                fieldCode: field,
                entityCode: "",
                placeNames: PlaceNameStatsItem
            };

            placeNameStatsList.push(newPlaceNameStat);
        });
        //count number of records for each field
       
        
        return placeNameStatsList;
    }

}